import React from "react"
import { useRecoilState, useResetRecoilState, useSetRecoilState } from "recoil"
import { useHistory } from "react-router-dom"
import { useSnackbar } from "notistack"
import { Formik, Form } from "formik"
// import * as Yup from "yup"
import { API, Auth, graphqlOperation } from "aws-amplify"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
// import Typography from "@material-ui/core/Typography"

import Button from "../components/Button"
import StepButtons from "../components/StepButtons"
import TextField from "../components/TextField"
import { addAssociationToUser, createDbUser } from "../libs/manageAccounts"
import currentAssociation from "../store/currentAssociation"
import currentUser from "../store/currentUser"
import onboardingProgress from "../store/onboardingProgress"
import { deleteInvite as DeleteInvite } from "../graphqlCustom/mutations"

const useStyles = makeStyles((theme) => ({
  button: {
    // marginRight: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
}))

export default function ConfirmEmail() {
  const classes = useStyles()
  const [isLoading, setIsLoading] = React.useState(false)
  const setAssociation = useSetRecoilState(currentAssociation)
  const [user, setUser] = useRecoilState(currentUser)
  const [progress, setProgress] = useRecoilState(onboardingProgress)
  const resetProgress = useResetRecoilState(onboardingProgress)
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()

  const resendHandler = async () => {
    setIsLoading(true)
    try {
      const response = await Auth.resendSignUp(progress.user.email)
      if (response) {
        enqueueSnackbar("Check your email")
      }
    } catch (error) {
      console.log("error", error)
      enqueueSnackbar(error.message, {
        variant: "error",
      })
    }
    setIsLoading(false)
  }

  async function deleteInvite(inviteId) {
    try {
      await API.graphql(graphqlOperation(DeleteInvite, { input: { id: inviteId } }))
    } catch (error) {
      console.log("error", error)
      enqueueSnackbar("Could not delete invite at this time", {
        variant: "error",
      })
    }
  }

  return (
    <Formik
      style={{ width: "100%" }}
      initialValues={{
        code: "",
      }}
      // validationSchema={Yup.object().shape({
      //   code: Yup.number()
      //     .test("len", "Should be 6 digits", (value) => value && value.toString().length === 6)
      //     .required("Email verification is required"),
      // })}
      //PostConfirmation failed with error InvalidParameterException: 2 validation errors detected: Value '' at 'groupName' failed to satisfy constraint: Member must have length greater than or equal to 1; Value '' at 'groupName' failed to satisfy constraint: Member must satisfy regular expression pattern: [\p{L}\p{M}\p{S}\p{N}\p{P}]+.
      validate={(values, props) => {
        const errors = {}

        if (!progress.user) {
          errors.code = "No user available, try signing in or start over"
        }
        if (!values.code) {
          errors.code = "Required"
        } else if (values.code.toString().length !== 6) {
          errors.code = "Should be 6 digits"
        }

        return errors
      }}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          if (!progress.user) {
            throw new Error("No user available, try signing in or start over")
          }
          const signUpResponse = await Auth.confirmSignUp(progress.user.email, values.code)
          if (!signUpResponse) {
            throw new Error("Code failed")
          }
          const userInfo = await Auth.signIn(progress.user.email, progress.user.password)
          // Create the user in the database
          const dbUser = await createDbUser({
            id: userInfo.attributes.sub,
            firstName: progress.user.firstName,
            lastName: progress.user.lastName,
            email: progress.user.email,
            phone: progress.user.phone,
          })
          // dbUser.email_verified = true
          setUser(dbUser)

          enqueueSnackbar("Successfully verified", {
            variant: "success",
          })
          // enqueueSnackbar("Welcome to Condo Axis")
          setProgress({
            ...progress,
            activeStep: progress.activeStep + 1,
            verify: false,
            verified: true,
            user: {
              ...progress.user,
              ...dbUser,
            },
          })
          if (progress.invite && progress.invite.association?.id) {
            await addAssociationToUser(
              progress.invite.association.id,
              user.id,
              progress.invite.role || null,
              progress.user.position || null,
              progress.user.unit || null
            )
            // associationId,
            // userId,
            // role = null,
            // title = null,
            // unit = null
            setAssociation({
              ...progress.invite.association,
            })
            deleteInvite(progress.invite.id)
            resetProgress()
            return history.push("/0")
          }
          // return history.push("/signup/association")
        } catch (error) {
          console.log("error", error)

          if (error.message === "User cannot be confirmed. Current status is CONFIRMED") {
            enqueueSnackbar("You are already confirmed", {
              variant: "error",
            })

            const userInfo = await Auth.signIn(progress.user.email, progress.user.password)

            // Create the user in the database
            const dbUser = await createDbUser({
              id: userInfo.attributes.sub,
              firstName: progress.user.firstName,
              lastName: progress.user.lastName,
              email: progress.user.email,
              phone: progress.user.phone,
            })
            // dbUser.email_verified = true
            setUser(dbUser)
            setProgress({
              ...progress,
              activeStep: progress.activeStep + 1,
              verify: false,
              verified: true,
              user: {
                ...progress.user,
                ...dbUser,
              },
            })
          } else {
            enqueueSnackbar(error.message, {
              variant: "error",
            })
          }
        }
        setSubmitting(false)
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        isSubmitting,
        isValid,
        touched,
        values,
        setFieldValue,
      }) => (
        <Form>
          <Grid container spacing={3}>
            <Grid item md={12}>
              <TextField
                autoFocus
                error={Boolean(touched.code && errors.code)}
                helperText={touched.code && errors.code}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.code}
                label="Confirmation Code"
                name="code"
              />
            </Grid>
            {/* <Grid item md={6}>
              <Typography style={{ lineHeight: "56px" }}>
                or{" "}
                <Button
                  color="primary"
                  component={RouterLink}
                  isLoading={isLoading}
                  to="/signin"
                  variant="text"
                >
                  Log In
                </Button>
              </Typography>
            </Grid> */}
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <StepButtons
                removeBack
                disableNext={!isValid}
                isLoading={isSubmitting}
                nextText="Confirm"
              />
            </Grid>
            <Grid item style={{ textAlign: "right" }} xs={6}>
              <Button
                className={classes.button}
                color="primary"
                isLoading={isLoading}
                onClick={resendHandler}
                size="small"
                variant="text"
              >
                Resend Code
              </Button>
            </Grid>
          </Grid>

          <div style={{ clear: "both", content: "", display: "block" }}></div>
        </Form>
      )}
    </Formik>
  )
}
